/**
 * CockpitHeaderPortal — portals children into a named DOM slot in the
 * parent CockpitPage's masthead controls area.
 *
 * Usage: place `<div id="my-target" className="contents" />` inside the
 * parent page's `controls` prop, then render
 * `<CockpitHeaderPortal targetId="my-target">{metrics}</CockpitHeaderPortal>`
 * from the embedded child — the metrics appear inline in the masthead.
 */
import { useState, useEffect } from "react";
import { createPortal } from "react-dom";

interface CockpitHeaderPortalProps {
  targetId: string;
  children: React.ReactNode;
}

export default function CockpitHeaderPortal({ targetId, children }: CockpitHeaderPortalProps) {
  const [host, setHost] = useState<HTMLElement | null>(null);
  useEffect(() => {
    const el = document.getElementById(targetId);
    setHost(el);
  }, [targetId]);
  if (!host) return null;
  return createPortal(<>{children}</>, host);
}
